<template>
	<fragment>
		<filter-sidebar v-if="includefilters === 'true'" v-bind:filters="filters" v-bind:secondaryfilters="secondaryFilters"></filter-sidebar>

		<div class="global-container">
			<section v-if="!displayCardItems" class="cards card--list section bg-white">
				<div class="row">
					<div v-if="sidebar !== null" class="col-md-3">
						<side-menu v-bind:sidebar="sidebar"
								   v-bind:hideChildren="sidebarHideChildren"
								   v-bind:header="sidebarHeader"></side-menu>
					</div>

					<div v-bind:class="sidebar !== null ? 'col-md-9' : 'col-md-12'" v-if="listing.length > 0">

						<div v-if="body !== null">
							<body-content></body-content>
						</div>

						<template v-if="displaytype == 'faq'">
							<archive-item-faq v-for="(item, index) in listing"
												  v-bind:item="item"
												  v-bind:displayDate="displayDate"
												  v-bind:displaySummary="displaySummary"
												  v-bind:key="item.DetailID"></archive-item-faq>
						</template>
						<template v-else>
							<archive-item v-for="(item, index) in listing"
										  v-bind:item="item"
										  v-bind:displayDate="displayDate"
										  v-bind:displaySummary="displaySummary"
										  v-bind:key="item.DetailID"></archive-item>
						</template>
						<section class="padding-top padding-bottom" v-if="listing.length > 0 && pagination.totalPages > 1">
							<div class="row">
								<div class="col-12">
									<pagination></pagination>
								</div>
							</div>
						</section>

					</div>

					<div class="col-md-9 align-center" v-if="listing.length === 0">

						<h2 class="not-found-heading">Sorry, no items were found matching your specifications.</h2>
						<p>
							Try removing some filters or searching a different term.
						</p>
					</div>
				</div>
			</section>
			<div v-if="displayCardItems">
				<div class="row cards--grid">
					<card-item v-for="(item, index) in listing"
							   v-bind:item="item"
							   v-bind:key="index"></card-item>
				</div>

				<section class="section bg-white" v-if="listing.length > 0 && pagination.totalPages > 1">
					<div class="row">
						<div class="col-12">
							<pagination></pagination>
						</div>
					</div>
				</section>

				<div class="col-md-12 align-center section" v-if="listing.length === 0">
					<h2 class="not-found-heading">Sorry, no items were found matching your specifications.</h2>
					<p>
						Try removing some filters or searching a different term.
					</p>
				</div>
			</div>
		</div>
	</fragment>
</template>

<script>
	import { mapState, mapActions, mapMutations } from 'vuex';
	import Pagination from '../components/listing/pagination-dropdown';
	import SideMenu from '../components/layout/side-menu';
    import ArchiveItem from '../components/listing/archive-item';
	import ArchiveItemFaq from '../components/listing/archive-item-faq';
    import CardItem from '../components/listing/card-item';
	import FilterSidebar from '../components/listing/filter-sidebar';
	import archivefilter from '../filters/archive-filter';
	import archivefilterDates from '../filters/archive-filter-dates';
	import listingFilter from '../filters/listing-filter';
	import * as CONST from '../utils/constants';
	import BodyContent from '../components/layout/body-content';

	export default {
		props: ['filterid', 'filtertype', 'displaytype', 'result', 'resource', 'includefilters'],
		data: function () {
			return {
				sidebar: CONST.globalProject.SideMenu,
				sidebarHeader: CONST.globalProject.SideMenuHeader,
				sidebarHideChildren: CONST.globalProject.HideSideMenuChildren || false,
				displayDate: CONST.globalProject.DisplayListingDates || false,
                displaySummary: CONST.globalProject.DisplayListingSummary || false,
                displayCardItems: CONST.globalProject.DisplayCardItems || false,
                body: CONST.globalProject.BodyContent || false,
				filters: {},
				secondaryFilters: null,
			}
		},
		computed: mapState({
			loading: state => state.listing.loading,
			listing: state => state.listing.listing,
			pagination: state => state.listing.pagination,
		}),
		components: {
			pagination: Pagination,
            'archive-item': ArchiveItem,
            'card-item': CardItem,
			'archive-item-faq': ArchiveItemFaq,
			'side-menu': SideMenu,
			'filter-sidebar': FilterSidebar,
			'body-content': BodyContent,
		},
		mounted: function () {
			let _this = this;

			// take props and send to vuex store
			this.setInitData(this.result);
			this.setResource(this.resource);

			// import correct filters for this view based on prop value
			if (this.filtertype === 'archiveFilter' && this.includefilters === 'true') {
				this.filters = archivefilter;
				if (Object.keys(archivefilterDates).length) {
					this.secondaryFilters = archivefilterDates;
				}
			} else {
				this.filters = listingFilter;
			};

			this.$store.subscribeAction((action, state) => {
				if (action.type === 'listing/setFilter') {
					$('html, body').animate({
						scrollTop: $('.filter-app').offset().top
					}, 1000);
				}
			})

			// if each spec change should trigger a new api call, use this. else manually call setFilter action on button click
			this.$store.subscribe((mutation, state) => {
				if (mutation.type === 'listing/updateSpecification') {
					this.setFilter();
				}
			});
		},
		methods: {
			...mapActions('listing', { setFilter: 'setFilter' }),
			...mapMutations('listing', { setInitData: 'setInitData' }),
			...mapMutations('listing', { setResource: 'setResource' }),
        },
    }
</script>
